import React from "react";
import Tool from "../manager_tool";
import DataSender from "../../lib/ManagerDataSender";

class PushupManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      allcheck: false,
      check: false,
    };
    this.ds = new DataSender();
  }

  componentDidMount() {
    this.update();
  }

  update() {
    this.ds
      .getTrain("P")
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          items: res.map((x) => {
            x["checked"] = false;
            return x;
          }),
        });
      })
      .catch((err) => {});
  }

  count(tis) {
    this.ds
      .getTrainCount("P")
      .then((res) => res.json())
      .then((res) => {
        tis.setState({ allperson: res.count });
      })
      .catch((err) => {});
  }

  deleteTrain() {
    let items = this.state.items.filter((x) => x.checked).map((x) => x.id);
    this.ds
      .deleteTrain({ items })
      .then(() => this.update())
      .catch((err) => {});
  }

  updateTrain(item) {
    item.count = parseInt(item.count);
    this.ds
      .updateTrain(item)
      .then(() => this.update())
      .catch((err) => {});
  }

  checkboxclick = (e) => {
    let id = parseInt(e.target.getAttribute("tid"));

    let items = [...this.state.items];
    let item = { ...this.state.items[id], checked: e.target.checked };
    items[id] = item;

    this.setState({ items });
  };

  checkAll = () => {
    let check = !this.state.allcheck;
    this.setState({
      items: this.state.items.map((x) => {
        return { ...x, checked: check };
      }),
      allcheck: check,
    });
  };

  render() {
    const items = this.state.items;
    const itt = this.state.items.find((x) => x.checked);
    return (
      <section>
        <div className="info02" style={{ width: "90%", marginLeft: "7%" }}>
          <div className="tb_w" style={{ width: "100%" }}>
            <h2>체력 측정 결과 관리</h2>
            <Tool
              item={itt}
              element={{ count: "팔굽혀펴기", uncount: "오자세" }}
              delete={this.deleteTrain.bind(this)}
              update={this.updateTrain.bind(this)}
              count={this.count.bind(this)}
            />
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={this.props.allCheck}
                      onChange={this.checkAll.bind(this.measur)}
                    />
                  </th>
                  <th>이름</th>
                  <th>전화번호</th>
                  <th>생년월일</th>
                  <th>부대(소속)</th>
                  <th>
                    <b>팔굽혀펴기</b>
                  </th>
                  <th>
                    <b>오자세</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((x, i) => {
                  return (
                    <tr key={i}>
                      {/* 값이 있을때 checkbox가 보여야 함 */}
                      <td>
                        <input
                          id="check"
                          tid={i}
                          type="checkbox"
                          checked={x.checked}
                          onChange={this.checkboxclick}
                        />
                      </td>
                      <td className="col" data-label="이름">
                        {x.soldier.name}
                      </td>
                      <td className="col" data-label="전화번호">
                        {x.soldier.phone_number}
                      </td>
                      <td className="col" data-label="생년월일">
                        {x.soldier.birth}
                      </td>
                      <td className="col" data-label="부대(소속)">
                        {x.soldier.army_unit.unitName}
                      </td>
                      <td className="col" data-label="팔굽혀펴기 횟수">
                        <b>{x.count}</b>
                      </td>
                      <td className="col" data-label="팔굽혀펴기 오자세">
                        <b>{x.uncount}</b>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default PushupManager;
